import { NgForm } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService } from '../services/service.index';
import { Usuario } from '../models/usuario.model';
import swal2 from 'sweetalert2';
import { environment } from '../../environments/environment';

declare function init_plugins();

@Component({
  selector: 'app-loginventus',
  templateUrl: './loginventus.component.html',
  styleUrls: ['./loginventus.component.css']
})
export class LoginVentusComponent implements OnInit {

  email: string;
  recuerdame = false;
  recuperacont = false;
  auth2: any;
  usuarios: any[] = [];
  imagen: string;
  // Backend URL Switch — DESHABILITADO tras migración a fargate.
  // Fecha desactivación: 09/09/2026
  // Referencia: .kiro/specs/backend-url-switch
  // // --- Backend URL Switch ---
  // /** URL alternativa leída del environment con fallback seguro. 08/07/2026 */
  // urlAlt: string = (environment as any).URL_SERVICIOS_ALT || '';
  // /** Indica si el toggle oculto está visible. 08/07/2026 */
  // showBackendToggle = false;
  // /** Indica si el override está activo. 08/07/2026 */
  // backendOverrideActive = false;
  // /** Contador de clics para el gesto secreto. 08/07/2026 */
  // private logoClickCount = 0;
  // /** Timestamp del primer clic del gesto. 08/07/2026 */
  // private logoClickTimer: any = null;
  constructor(
    public router: Router,
    public _usuarioService: UsuarioService
  ) { }

  async ngOnInit() {
    init_plugins();
    this.imagen = environment.CLIENTE;
    this.email = localStorage.getItem('email') || '';
    if ( this.email.length > 1 ) {
      this.recuerdame = true;
    }

    // Backend URL Switch — DESHABILITADO tras migración a fargate.
    // Fecha desactivación: 09/09/2026
    // Referencia: .kiro/specs/backend-url-switch
    // // Inicializar estado del toggle desde sessionStorage
    // this.backendOverrideActive = !!sessionStorage.getItem('API_BASE_URL_OVERRIDE');
  }

  recuperarcont() {
    this.recuperacont = !this.recuperacont;
    console.log(this.recuperacont);
  }

  ingresar( forma: NgForm) {
    swal2.fire('Espere, por favor')
    swal2.showLoading();
    if ( forma.invalid ) {
      return;
    }
    const usuario = new Usuario(null, forma.value.email, forma.value.password );
    this._usuarioService.login( usuario, forma.value.recuerdame )
                  .subscribe( correcto => {  localStorage.setItem('quiensoy', 'ventus' );
                    setTimeout(() => {
                      this.router.navigate(['/dashboard']);
                      swal2.close();
                    }, 1000);
                }, (err) => {
                  swal2.fire(
                       'Error al Acceder',
                       'Revise su información',
                       'error'
                    );
                 }  );

  }

  enviacrecuperacion() {
    const email = (document.getElementById('emailrec') as HTMLInputElement).value;
    this._usuarioService.getResetPaswword(email).subscribe( resp => { this.recuperacont = !this.recuperacont;
                                                                      swal2.fire(
        'El correo de recuperación de contraseña fue enviado a:',
        email,
        'success'
     );
    }, (err) => {
      console.log(err);
      swal2.fire(
           'Error',
           err.error.errors[0],
           'error'
        );
     } );

  }

  // Backend URL Switch — DESHABILITADO tras migración a fargate.
  // Fecha desactivación: 09/09/2026
  // Referencia: .kiro/specs/backend-url-switch
  // /**
  //  * Detecta el gesto secreto: 5 clics en el logo dentro de 3 segundos.
  //  * Si URL_SERVICIOS_ALT no tiene valor, no hace nada.
  //  * 08/07/2026
  //  */
  // onLogoClick(): void {
  //   if (!this.urlAlt) {
  //     return;
  //   }
  //   this.logoClickCount++;
  //   if (this.logoClickCount === 1) {
  //     this.logoClickTimer = setTimeout(() => {
  //       this.logoClickCount = 0;
  //     }, 3000);
  //   }
  //   if (this.logoClickCount >= 5) {
  //     clearTimeout(this.logoClickTimer);
  //     this.logoClickCount = 0;
  //     this.showBackendToggle = !this.showBackendToggle;
  //   }
  // }
  //
  // /**
  //  * Alterna el override de URL en sessionStorage.
  //  * 08/07/2026
  //  */
  // toggleBackendUrl(): void {
  //   if (this.backendOverrideActive) {
  //     sessionStorage.removeItem('API_BASE_URL_OVERRIDE');
  //     this.backendOverrideActive = false;
  //   } else {
  //     sessionStorage.setItem('API_BASE_URL_OVERRIDE', this.urlAlt);
  //     this.backendOverrideActive = true;
  //   }
  // }
  //
  // /**
  //  * Retorna el texto para el tooltip del logo indicando el backend activo.
  //  * 08/07/2026
  //  */
  // getLogoTooltip(): string {
  //   if (this.backendOverrideActive) {
  //     return 'Backend Alternativo: ' + this.urlAlt;
  //   }
  //   return 'Backend Default: ' + environment.URL_SERVICIOS;
  // }

}
